import { useState } from "react";
import {
  useDisclosure,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";

const useContinueConfirmationDialog = (deleteItem) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isProcessing, setIsProcessing] = useState(false);
  const [itemId, setItemId] = useState(null);

  const handleConfirmAction = async () => {
    setIsProcessing(true);
    await deleteItem(itemId);
    setIsProcessing(false);
    onClose();
  };

  const openConfirmationDialog = (id) => {
    setItemId(id);
    onOpen();
  };

  const Dialog = (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={undefined}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Update Stage
          </AlertDialogHeader>

          <AlertDialogBody>
            Are you sure you want to do this action? This action cannot be
            undone.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} disabled={isProcessing}>
              Cancel
            </Button>
            <Button
              onClick={() => handleConfirmAction()}
              colorScheme="blue"
              ml={3}
              isLoading={isProcessing}
            >
              Continue
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );

  return {
    isOpen,
    onClose,
    isProcessing,
    openConfirmationDialog,
    Dialog,
  };
};

export default useContinueConfirmationDialog;
